import { TriangleAlert } from 'lucide-react';
import React from 'react';
import { describeSegmentReuseProblem, type SegmentUsage } from './segment-usage';
import { UNNAMED_SEGMENT_LABEL } from './segment-picker-copy';
import styles from './SegmentPicker.module.css';

interface SegmentReuseWarningProps {
  segmentName: string | undefined;
  pickedUsage: SegmentUsage;
  usagesElsewhere: SegmentUsage[] | undefined;
}

export const SegmentReuseWarning: React.FC<SegmentReuseWarningProps> = ({
  segmentName,
  pickedUsage,
  usagesElsewhere,
}) => {
  const warning = describeSegmentReuseProblem(segmentName ?? UNNAMED_SEGMENT_LABEL, [
    pickedUsage,
    ...(usagesElsewhere ?? []),
  ]);
  if (!warning) return null;
  return (
    <p role="alert" className={styles.reuseWarning}>
      <TriangleAlert aria-hidden="true" />
      {warning}
    </p>
  );
};
